import { render, staticRenderFns } from "./list-exhibition.vue?vue&type=template&id=55de8c2e&scoped=true&"
import script from "./list-exhibition.vue?vue&type=script&lang=ts&"
export * from "./list-exhibition.vue?vue&type=script&lang=ts&"
import style0 from "./list-exhibition.vue?vue&type=style&index=0&id=55de8c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de8c2e",
  null
  
)

export default component.exports